var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h3',[_vm._v("Querylogs dashboard")]),(_vm.isLoading)?_c('progress-bar'):_vm._e(),_c('WorkerQuerylogsManagerWrapper',{attrs:{"baseHeaders":_vm.baseHeaders,"amlHeaders":_vm.amlHeaders},on:{"submit":_vm.submitQuerylogs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }